import { Assignment } from "./Assignment";
import { AssignmentItem } from "./AssignmentItem";

export class AssignedAssessment extends AssignmentItem
{
    private assessmentId:number;
    private uid:string;

    public constructor() {
        super();
        this.uid = "";
        this.Type = "Assessment";
    }

    public get AssessmentId() : number {
        return this.assessmentId;
    }

    public set AssessmentId(v:number) {
        this.assessmentId = v;
    }

    public get Uid() : string {
        return this.uid;
    }
    
    
    public set Uid(v : string) {
        this.uid = v;
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/models/AssignedAssessment.ts